// removed by extract-text-webpack-plugin
module.exports = {"page":"components-SideMenu-style__page__265sr","code-example":"components-SideMenu-style__code-example__1XFQC","codeExample":"components-SideMenu-style__code-example__1XFQC","screenshot":"components-SideMenu-style__screenshot__2rj7B","sidemenu":"components-SideMenu-style__sidemenu__WTPyk","selected":"components-SideMenu-style__selected__2q_ew","separator":"components-SideMenu-style__separator__3rXg4"};


//////////////////
// WEBPACK FOOTER
// ./components/SideMenu/style.scss
// module id = 605
// module chunks = 0